import { render, staticRenderFns } from "./deanHeaderSearch.vue?vue&type=template&id=f0cdb6f4&scoped=true"
import script from "./deanHeaderSearch.vue?vue&type=script&lang=ts"
export * from "./deanHeaderSearch.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderSearch.vue?vue&type=style&index=0&id=f0cdb6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cdb6f4",
  null
  
)

export default component.exports